
  import { Vue, Component } from "vue-property-decorator";
  import ModalFullScreen from "@/components/modal/ModalFullScreen.vue";
  import UiButton from "@/components/button/ui-button.vue";
  import ModalSectionsDivider from "@/components/modal/ModalSectionsDivider.vue";
  import ModalHeader from "@/components/modal/ModalHeader.vue";

  @Component({
    components: {
      ModalHeader,
      ModalSectionsDivider,
      ModalFullScreen,
      UiButton,
    },
  })
  export default class CardRequiredModal extends Vue {
  }
